export const AUTH_REQUEST = "AUTH_REQUEST";
export const AUTH_SUCCESS = "AUTH_SUCCESS";
export const AUTH_FAIL = "AUTH_FAIL";
export const AUTH_RESET = "AUTH_RESET";

export const GET_ME_REQUEST = "GET_ME_REQUEST";
export const GET_ME_SUCCESS = "GET_ME_SUCCESS";
export const GET_ME_FAIL = "GET_ME_FAIL";

export const GET_DP_REQUEST = "GET_DP_REQUEST";
export const GET_DP_SUCCESS = "GET_DP_SUCCESS";
export const GET_DP_FAIL = "GET_DP_FAIL";
